import React from "react";
import { Container } from "react-bootstrap";

const Kennzahlen = () => {
  return (
    <Container className="mt-4">
    <h2 className="section-title">Kennzahlen</h2>
    <div className="section-title-underline"></div>
      {/* ---------------- Epidemiologische Maßzahlen ---------------- */}
      <h4 className="mt-3 mb-3">Epidemiologische Maßzahlen</h4> 
      <div className="aktuelles-text">
      

      <h5>Anzahl der Neuerkrankungen (Inzidenz)</h5>
      <p>
        Die absoluten Fallzahlen zeigen die jährliche Anzahl der
        Neuerkrankungen bei Erwachsenen, die dem KR-LSA gemeldet wurden. Diese
        werden nach Geschlecht stratifiziert dargestellt.
      </p>

      <h5>Neuerkrankungsraten (Inzidenzrate)</h5>
      <p>
        Die Neuerkrankungsrate entspricht der Anzahl der gemeldeten
        Krebsneuerkrankungen pro 100 000 Einwohner Sachsen-Anhalts innerhalb
        eines Jahres. Ebenso werden altersspezifische Neuerkrankungsraten für
        jeweils 5-Jahres-Altersgruppen berechnet. Die Populationsgröße zur
        Berechnung der Neuerkrankungsrate stammt aus dem Bevölkerungsstand des
        jeweiligen Jahres des Statistischen Landesamtes des Landes
        Sachsen-Anhalt <strong>[1]</strong>.
      </p>

      <h5>Altersstandardisierte Inzidenzraten</h5>
      <p>
        Um Sachsen-Anhalt mit anderen Bundesländern oder Staaten zu vergleichen
        oder um verschiedene Landkreise miteinander vergleichen zu können, wird
        für die unterschiedliche Alters- und Geschlechtsstrukturen durch
        Standardisierung adjustiert. Dabei werden die Daten des Statistischen
        Landesamtes und die „alte Europastandardbevölkerung“ verwendet{" "}
        <strong>[2]</strong>.
      </p>

      <h5>Überleben</h5>
      <p>
        Die Kaplan-Meier-Kurven werden zur Darstellung des absoluten Überlebens
        stratifiziert nach Eigenschaften der Tumoren zum Zeitpunkt der Diagnose
        dargestellt. Das KR-LSA erhält Informationen zu Sterbedaten aus den
        Gesundheitsämtern und den Meldeämtern des Landes.
      </p>

      {/* ---------------- Klinische Kennzahlen ---------------- */}
      <h3 className="mt-4">Klinische Kennzahlen</h3>

      <h5>Medianes Erkrankungsalter</h5>
      <p>
        Als Erkrankungsalter wird der Median des Alters bei Diagnosestellung
        angegeben. Das heißt, 50 % der erkrankten Personen waren zum Zeitpunkt
        der Diagnose jünger und 50 % älter.
      </p>

      <h5>Lokalisation und Histologie</h5>
      <p>
        Die Lokalisation und die Histologie der Tumoren wird anhand der ICD-O-3
        Klassifikation <strong>[3]</strong> angegeben. Während die Lokalisation
        den Sitz der Tumoren beschreibt (mit drei bis vier Stellen), gibt die
        Histologie die Art des Tumorgewebes an.
      </p>

      <h5>Histopathologisches Grading</h5>
      <p>
        Das histopathologische Grading gibt den Differenzierungsgrad des
        Tumorgewebes an. Angefangen bei Stadium „G1“, welches für gut
        ausgereiftes, normales Gewebe steht, reicht die Klassifikation bis
        „G4“ für undifferenziertes Gewebe. „GX“ bedeutet, dass der
        Differenzierungsgrad nicht bestimmt werden kann. Die Ausprägungen high
        (GH = G3–G4), intermediate (GM = G2–G3) und low (GL = G1–G2) wurden GX
        zugeordnet, da sie sich nicht eindeutig den Histologiegraden G1–G4
        zuordnen lassen.
      </p>
      <p>
        Für die histologische Beurteilung des Prostatakarzinoms wird der
        Gleason-Score und für maligne Melanome das Clark-Level verwendet.
      </p>

      <h5>TNM-Klassifikation und UICC-Stadien</h5>
      <p>
        Die Darstellung der TNM-Klassifikation beruht auf den Angaben der T-, N-
        und M-Kategorie der TNM-Klassifikation maligner Tumoren{" "}
        <strong>[4]</strong>. T steht für die Größe und Ausbreitung des
        Primärtumors, N für das Fehlen oder Vorhandensein von
        Lymphknotenmetastasen, M für das Vorhandensein von Fernmetastasen.
      </p>
      <p>
        Die Stadieneinteilung nach UICC erfolgt tumorspezifisch. Die
        TNM-Klassifikation kann klinisch (cTNM) oder pathologisch (pTNM)
        beurteilt werden. Im Bericht wurde cTNM verwendet, wenn keine pTNM
        vorlag oder eine neoadjuvante Therapie vorausging. Die TNM-Erhebung
        muss innerhalb von 92 Tagen nach Diagnose erfolgt sein.
      </p>

      <h5>Metastasenlokalisation</h5>
      <p>
        Die Lokalisation von Fernmetastasen wird für die folgenden Organe
        einzeln dargestellt: Haut, Hirn, Knochen, Knochenmark, Leber, Lunge,
        Lymphknoten, Nebennieren, Peritoneum, Pleura sowie weitere Organe.
        Berücksichtigt werden Befunde bis 92 Tage nach Diagnose.
      </p>

      <h5>Primärtherapie</h5>
      <p>
        Als Primärtherapie gelten alle Maßnahmen, die innerhalb von 365 Tagen nach der Diagnose begonnen wurden und sich auf den Primärtumor beziehen.
        Operationen werden über OPS-Codes erfasst. Dabei werden ausschließlich OPS-Codes berücksichtigt, die sich auf die Therapie der Primärlokalisation beziehen. 
        Rein diagnostische Eingriffe sowie tumorferne Maßnahmen werden nicht als Primärtherapie gezählt.
      </p>
      <p>
        Behandlungsarten wie Chemo-, Immun- oder Strahlentherapie werden je nach Verfügbarkeit der Daten berücksichtigt.
        Hormontherapien können aufgrund der aktuellen Datenlage nicht separat dargestellt werden.
        Zielgerichtete Therapien werden nicht als eigene Kategorie ausgewiesen, sondern sind in der Kategorie „Chemo- und Immuntherapien“ eingeschlossen.
        Fehlende Angaben zu Therapien bedeuten nicht zwangsläufig, dass keine Behandlung erfolgt ist, sondern können auch auf unvollständige oder nicht verfügbare Meldungen zurückzuführen sein.
      </p>

      <p> 
        Die Kategorie „keine gemeldete Primärtherapie“ umfasst Fälle, bei denen innerhalb von 365 Tagen nach Diagnose keine Primärtherapie gemeldet wurde.
        In dieser Kategorie sind unter anderem auch Strategien wie „Watch and Wait“ sowie „Active Surveillance“ enthalten, 
        da diese derzeit nicht separat ausgewiesen werden können.
      </p>

      <h5>Lokaler Residualstatus nach Tumorresektion</h5>
      <ul>
        <li>
          <strong>R0:</strong> kein Residualtumor
        </li>
        <li>
          <strong>R1:</strong> mikroskopischer Residualtumor
        </li>
        <li>
          <strong>R2:</strong> makroskopischer Residualtumor
        </li>
        <li>
          <strong>RX / k.A.:</strong> nicht beurteilbar / keine Angabe
        </li>
      </ul>
      <p>
        Berücksichtigt wurden nur OPS-Codes mit erwartbarer R0-Resektion gemäß
        Plattform § 65c.
      </p>

      <h5>Medianzeit zwischen Diagnose und Therapiebeginn</h5>
      <p>
        Die Zeitspanne zwischen Diagnose und Beginn der Therapie wird als Median
        pro Entität dargestellt. Die Visualisierung erfolgt über Boxplots.
      </p>

      {/* ---------------- Referenzen ---------------- */}
      <div className="mt-4 pt-3 border-top" style={{ fontSize: "0.95rem" }}>
        <h6>Referenzen</h6>
        <p className="mb-1">
          <strong>[1]</strong> Statistisches Landesamt Sachsen-Anhalt.
          Bevölkerungsstand nach Geschlecht und Altersjahren am 31.12.2020.
          https://statistik.sachsen-anhalt.de/themen/bevoelkerung-mikrozensus-freiwillige-haushaltserhebungen/bevoelkerung/tabellen-bevoelkerungsstand
        </p>
        <p className="mb-1">
          <strong>[2]</strong> Waterhouse JAH, Muir CS, Correa P, Powell J,
          eds. Cancer incidence in five continents. Lyon: IARC, 1976; 3: 456.
        </p>
        <p className="mb-1">
          <strong>[3]</strong> WHO. International Classification of Diseases for
          Oncology, 2. Revision, 2019,
          https://www.dimdi.de/static/de/klassifikationen/icd/icd-o-3/icdo3rev1html/chapter-m.htm
        </p>
        <p className="mb-0">
          <strong>[4]</strong> TNM Klassifikation maligner Tumoren. C. Wittekind 
          (Herausgeber). 8. Auflage Januar 2017.
        </p>
      </div>
      </div>
    </Container>
  );
};

export default Kennzahlen;


